/* --------------------------------------------------------------------------
	Background Video Controls
-------------------------------------------------------------------------- */

	"use strict";
	
	var $ = jQuery;

	function initBackground() {
		$(".js-background-video").each(function () {
			backgroundVideo(this);
		});
	}

	function backgroundVideo(element) {
		var $background = $(element);
		var parent = $background.parent();
		var video = parent.find('video');
		var playbtn = parent.find(".js-background-control-play")
		var pausebtn = parent.find(".js-background-control-pause")

		function onPlayClick() {
			if (video.length > 0) {
				video[0].play();
			}
			playbtn.addClass("background-control-active")
					   .attr("aria-pressed", "true");
	
			pausebtn.removeClass("background-control-active")
					   .attr("aria-pressed", "false");
		}
	
		function onPauseClick() {
			if (video.length > 0) {
				video[0].pause();
			}
			pausebtn.addClass("background-control-active")
					   .attr("aria-pressed", "true");
	
			playbtn.removeClass("background-control-active")
					   .attr("aria-pressed", "false");
		}

		playbtn.on("click", onPlayClick);
		pausebtn.on("click", onPauseClick);
	}

	$(initBackground);
